// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// constant import
import { MessageInterval } from '../../../_constants/messages-intervals';

// component imports
import { WorkOrderBaseComponent } from '../../_base/work-order-base-component';
import { ManageClosedInvoicesComponent } from './manage-closed-invoices/manage-closed-invoices.component';
import { ManageOpenInvoicesComponent } from './manage-open-invoices/manage-open-invoices.component';

// model imports
import { WorkOrderManageWorkFlowParametersDto } from '../../_models/work-order-manage-workflow-parameters-dto';
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';

@Component({
    selector: 'app-work-order-manage-invoices',
    templateUrl: './work-order-manage-invoices.component.html',
    styleUrls: ['./work-order-manage-invoices.component.scss']
})
export class WorkOrderManageInvoicesComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('manageInvoicesPopup', { static: false }) manageInvoicesPopup: DxPopupComponent;
    @ViewChild('openInvoices', { static: false }) openInvoices: ManageOpenInvoicesComponent;
    @ViewChild('closedInvoices', { static: false }) closedInvoices: ManageClosedInvoicesComponent;

    @Input() workOrderId: number;
    @Input() communityId: number;
    @Input() invoiceIds: Array<number> = [];

    @Output() onClose = new EventEmitter<boolean>();

    visible = false;
    manageWorkOrderInvoiceTitle: string;
    isInvoiceSaved = false;

    tabItems: Array<KeyValueResultDto> = [];
    selectedTabItem: KeyValueResultDto;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.manageWorkOrderInvoiceTitle = `Manage Invoice For Work Order: ${this.workOrderId}`;
        this.show();
        this.configureDefaults();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.manageInvoicesPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeManageInvoices();
    }

    onSaveClick(): void {
        if (Utils.equalsIgnoreCase(this.selectedTabItem.key, 'openInvoices')) {
            this.saveWorkflowInvoices(this.openInvoices.getWorkflowParamter());
        } else {
            this.saveWorkflowInvoices(this.closedInvoices.getWorkflowParamter());
        }
    }

    onCloseClick(): void {
        this.closeManageInvoices();
    }

    private configureDefaults(): void {
        this.tabItems = [
            {
                displayText: 'Open Invoices',
                key: 'openInvoices',
                isDefault: true
            },
            {
                displayText: 'Closed Invoices',
                key: 'closedInvoices',
                isDefault: false
            }
        ];
        this.selectedTabItem = this.tabItems[0];
    }

    private closeManageInvoices(): void {
        this.visible = false;

        this.onClose.emit(this.isInvoiceSaved);
    }

    private saveWorkflowInvoices(baseParams: WorkOrderManageWorkFlowParametersDto): void {
        this.workOrderHelperService.showLoading();
        this.workOrderService.manageWorkflows(baseParams).subscribe(
            (result: any) => {
                notify(
                    'Successfully linked selected invoice(s) to work order',
                    'Success',
                    MessageInterval.successMsgInterval
                );
                this.isInvoiceSaved = true;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }
}
